import { render, staticRenderFns } from "./lawyerHome.vue?vue&type=template&id=6e4ab5fe&scoped=true"
import script from "./lawyerHome.vue?vue&type=script&lang=js"
export * from "./lawyerHome.vue?vue&type=script&lang=js"
import style0 from "./lawyerHome.vue?vue&type=style&index=0&id=6e4ab5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ab5fe",
  null
  
)

export default component.exports